<div>
  <app-hero appLanguageClass></app-hero>
  <app-about-me appLanguageClass></app-about-me>
  <app-skills appLanguageClass></app-skills>
  <app-portfolio appLanguageClass></app-portfolio>
  <app-references appLanguageClass></app-references>
  <app-contact appLanguageClass></app-contact>
  <img class="shadow-ref" src="/assets/shadows/shadow-reference.svg" alt="" />
</div>
